import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { authClientForUrl } from '@web/shared-functions/auth';
import { AuthProviderFactory } from '../services/auth/auth-provider.factory';

export const userIsAuthenticatedGuard: CanActivateChildFn = async (
  _route,
  state
) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return false;
  }

  const auth = inject(AuthProviderFactory).getProvider(
    authClientForUrl(state.url)
  );

  try {
    await auth.initialize();
  } catch {
    return false;
  }

  if (auth.isLoggedIn()) {
    return true;
  }

  auth.login();
  return false;
};
